import app from 'flarum/app';

import extractText from 'flarum/utils/extractText';
import {extend} from 'flarum/extend';
import {override} from 'flarum/extend';

import Button from 'flarum/components/Button';
import ItemList from 'flarum/utils/ItemList';
import SignUpModal from 'flarum/components/SignUpModal';
import HeaderSecondary from 'flarum/components/HeaderSecondary';

export default function () {
  override(SignUpModal.prototype, 'fields', function () {
    const items = new ItemList();

    const usernameLabel = extractText(app.translator.trans('core.forum.sign_up.username_placeholder'));
    const emailLabel = extractText(app.translator.trans('core.forum.sign_up.email_placeholder'));
    const passwordLabel = extractText(app.translator.trans('core.forum.sign_up.password_placeholder'));

    items.add('username',
      <div className="Form-group">
        <input
          className="FormControl"
          name="username"
          type="text"
          placeholder={usernameLabel}
          aria-label={usernameLabel}
          value={this.username()}
          disabled={this.loading || this.isProvided('username') || this.attrs.token}
        />
      </div>,
      30
    );

    items.add('email',
      <div className="Form-group">
        <input
          className="FormControl"
          name="email"
          type="email"
          placeholder={emailLabel}
          aria-label={emailLabel}
          value={this.email()}
          disabled={this.loading || this.isProvided('email') || this.attrs.token}
        />
      </div>,
      20
    );

    if (!this.attrs.token) {
      items.add('password',
        <div className="Form-group">
          <input
            className="FormControl"
            name="password"
            type="password"
            placeholder={passwordLabel}
            aria-label={passwordLabel}
            value={this.password()}
            disabled={this.loading || this.attrs.token}
          />
        </div>,
        10
      );
    }

    items.add('submit', <div className="Form-group">
      <Button
        className="Button Button--primary Button--block"
        type="submit"
        loading={this.loading}>
        {app.translator.trans('core.forum.sign_up.submit_button')}
      </Button>
    </div>, -10);

    return items;
  });

  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.remove('signUp');

    return items;
  });
}
